






























import { Component, Vue, Ref } from 'vue-property-decorator';
import { BulletinEntity } from '@/entities/bulletin.entity';
import CreateListDataMixin from '@/mixin/ListDataMixin';
import BulletinItem from '@/components/ViewComponent/Bulletin/BulletinItem/BulletinItem.vue';
import CDivider from '@/components/Helper/CDivider.vue';
import { mapActions } from 'vuex';

const join = ['comments', 'staff'];

@Component<BulletinList>({
  components: { CDivider, BulletinItem },
  methods: {
    ...mapActions('staff', ['fetchCurrentStaff']),
  },
})
export default class BulletinList extends CreateListDataMixin<BulletinEntity>(
  'bulletin',
  'bulletin',
  join,
) {
  // items: BulletinEntity[] = [];
  fetchCurrentStaff!: () => void;

  @Ref('container')
  container: Vue;

  loading = false;

  async afterFirstFetch(): Promise<any> {
    if (
      !this.$route.params.id &&
      this.items.length > 0 &&
      !this.$route.path.includes('create')
    ) {
      await this.$router.push(`/bulletin/${this.items[0].id}`);
    }
  }

  get scrollEl(): Window | Element {
    if (!this.container) {
      return null;
    }
    return this.container.$el;
  }
  mounted() {
    this.$cheeers.socket.on('notify_bulletin@new_comment', async (data) => {
      const { id } = this.$route.params;
      this.refreshItem(data.id);
      if (Number(id) === data.id) {
        await this.$http.patch('/notify-bulletin/isread-notify-bulletin', {
          bulletinId: Number(id),
        });
      }
    });
  }
}
